import type { SsoConfig } from '@nota/sso';

const envBool = (v: string | undefined): boolean => {
  if (!v) return false;
  return ['true', '1', 'yes', 'on'].includes(v.trim().toLowerCase());
};

export const isSsoEnabled = (): boolean => {
  if (!envBool(process.env.REACT_APP_NOTA_SSO_ENABLED)) return false;
  const authority = process.env.REACT_APP_NOTA_SSO_AUTHORITY;
  const redirectUri = process.env.REACT_APP_NOTA_SSO_REDIRECT_URI;
  return !!authority?.trim() && !!redirectUri?.trim();
};

export const getSsoConfig = (): SsoConfig => {
  const authority = (process.env.REACT_APP_NOTA_SSO_AUTHORITY ?? '').trim().replace(/\/+$/, '');
  const redirectUri = (process.env.REACT_APP_NOTA_SSO_REDIRECT_URI ?? '').trim();
  const postLogoutRedirectUri =
    (process.env.REACT_APP_NOTA_SSO_POST_LOGOUT_URI ?? '').trim() ||
    `${window.location.origin}/login`;

  return {
    clientId: 'nota-wine-web',
    authority,
    redirectUri,
    postLogoutRedirectUri,
    scope: 'openid admin',
    resource: 'urn:nota:api',
    postLoginRedirectUri: '/admin',
    loginPath: '/login',
  };
};
